import { render, staticRenderFns } from "./AverageFlight.vue?vue&type=template&id=0534da62"
import script from "./AverageFlight.vue?vue&type=script&lang=js"
export * from "./AverageFlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports